import { Component } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { NotificationListProps } from './FlexNotificationProps';
import IbssSvgIcon from '../../../../Components/Icons/SvgIcon/IbssSvgIcon';
import { Icons } from '../../../../Common/AllsvgIcons'; 
import { DateHelper } from '../../../../Common/DateHelper';

class NotificationDetails extends Component<{ details: NotificationListProps, removeNotificationDetails: () => void }> {
  render() {
    const { details } = this.props;
    const htmlContent = `
    <html>
      <head>
        <style>
          /* Inline styles from details.Notification_Message */
        </style>
      </head>
      <body>${details.Notification_Message}</body>
    </html>
  `;
 
    // get Date format
    const availableDate = DateHelper.fromIsoByNode(details.Available_From, details.Node_Id).toLocaleDateTimeString()

    return (
      <>
        <Box className="notification-right-pannel">
          <Box>
            <img className="notification-details-img" src={`${details.ImageURI ? details.ImageURI : 'images/FlexNotificationImage.svg'}`} />
          </Box>
          <Box className="notification-details-card">
            <div className="d-flex justify-content-between">
              <Typography className="text-info-xs">
                {details.Subclassification} | {availableDate}
              </Typography>
              <span className="text-ui-md pointer" onClick={() => this.props.removeNotificationDetails()}>
                <IbssSvgIcon>{Icons.CloseIcon}</IbssSvgIcon>
              </span>
            </div>
            <Typography className="card-userPref-text" variant='h6'>
              {details.Notification_Title}
            </Typography>
           <iframe
                srcDoc={htmlContent}
                style={{ width: "100%", height: "300px", border: "none" }}
              />
            {/* <Link className="pointer">
             {this.labels.HubLabelFindOut}
            </Link> */}
          </Box>
        </Box>
      </>
    )
  }
}

export default NotificationDetails;
